<div class="modal-header bg-white">
  <h5 class="modal-title" id="staticBackdropLabel" i18n="@@UpdateChargingStationHeader">
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-cpu"><rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect><rect x="9" y="9" width="6" height="6"></rect><line x1="9" y1="1" x2="9" y2="4"></line><line x1="15" y1="1" x2="15" y2="4"></line><line x1="9" y1="20" x2="9" y2="23"></line><line x1="15" y1="20" x2="15" y2="23"></line><line x1="20" y1="9" x2="23" y2="9"></line><line x1="20" y1="14" x2="23" y2="14"></line><line x1="1" y1="9" x2="4" y2="9"></line><line x1="1" y1="14" x2="4" y2="14"></line></svg>&nbsp;&nbsp; Update-Assistent
  </h5>
  <button type="button" id="x_close" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
</div>
<div class="modal-body">
  <form>
    <p class="text-muted" i18n="@@UploadFirmwareMessage">Bitte das gewünschte Firmware-Paket hier hochladen:</p>
    <div class="input-group mb-3">
      <input type="file" id="firmware" class="form-control" />
      <button class="btn btn-primary" id="upload" ngbTooltip="Update hochladen" i18n-ngbToolTip="@@UploadFirmwareTooltip" (click)="uploadChargingStationFirmware()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-upload-cloud"><polyline points="16 16 12 12 8 16"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path><polyline points="16 16 12 12 8 16"></polyline></svg>
      </button>
    </div>
    <h6 i18n="@@AllChargingStationsAvailableForUpdateHeader">alle Ladestationen die derzeit für ein Update verfügbar sind</h6>
    <table *ngIf="this.loading == true" class="table table-striped table-responsive table-scrollable table-borderless mt-0 pt-0" style="width:100%;max-height:400px;display:table">
      <thead style="position: sticky;top: 0" class="thead-light">
        <tr>
          <th class="header" scope="col">&nbsp;</th>
          <th class="header" scope="col" i18n="@@Name">Name</th>
          <th class="header" scope="col" i18n="@@Firmware">Firmware</th>
          <th class="header" scope="col" i18n="@@Customer">Kunde</th>
          <th class="header" scope="col" i18n="@@Status">Status</th>
          <th class="header" scope="col" i18n="@@Progress">Fortschritt</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let station of chargingStations;let i of index;">
          <td><input type="checkbox" name="{{station.id}}" /></td>
          <td>{{station.name}}</td>
          <td>{{station.firmware}}</td>
          <td>{{station.customer.name}}</td>
          <td><span [innerHTML]="station.displayStatus"></span></td>
          <td>
            <div class="progress">
              <div class="progress-bar progress-bar-striped bg-dark" role="progressbar" style="width: 100%;" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">0%</div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </form>
 </div>

<div class="modal-footer">
  <button type="button" id="cancel" class="btn btn-danger" data-bs-dismiss="modal" i18n="@@CancelButton" (click)="closeModal()">
    Abbrechen
  </button>

  <button class="btn btn-primary ms-1" id="update" ngbTooltip="ausgewählte Ladestationen updaten" i18n-ngbTooltip="@@UpdateChosenChargingStationsTooltip" (click)="updateChargingStations()" [disabled]="!updateReady">
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-cpu"><rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect><rect x="9" y="9" width="6" height="6"></rect><line x1="9" y1="1" x2="9" y2="4"></line><line x1="15" y1="1" x2="15" y2="4"></line><line x1="9" y1="20" x2="9" y2="23"></line><line x1="15" y1="20" x2="15" y2="23"></line><line x1="20" y1="9" x2="23" y2="9"></line><line x1="20" y1="14" x2="23" y2="14"></line><line x1="1" y1="9" x2="4" y2="9"></line><line x1="1" y1="14" x2="4" y2="14"></line></svg>&nbsp;Updaten    
  </button>
</div>

  


